import { render, staticRenderFns } from "./ColumnRoyaltiesManagement.vue?vue&type=template&id=949940a6&scoped=true"
import script from "./ColumnRoyaltiesManagement.vue?vue&type=script&lang=js"
export * from "./ColumnRoyaltiesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949940a6",
  null
  
)

export default component.exports